import ExcelJS from "exceljs";

export default class ProdRecetarioAYBExcel {
  static generateWorkbook(data) {
    if (!data || !data.Productos || !Array.isArray(data.Productos)) {
      console.error("Error: data.Productos no es un array válido", data);
      return null;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Recetario AYB");

    // Definir encabezados incluyendo la nueva columna "Unidad de Medida"
    const headers = [
      "Tipo Insumo",
      "Insumo",
      "Cantidad",
      "Unidad de Medida",
      "Costo Insumo",
    ];
    const numColumns = headers.length;
    const lastColLetter = String.fromCharCode(64 + numColumns);

    // Agregar el título "RECETARIO"
    const titleRow = worksheet.addRow(["RECETARIO"]);
    worksheet.mergeCells(
      `A${titleRow.number}:${lastColLetter}${titleRow.number}`
    );
    titleRow.getCell(1).font = { bold: true, size: 18 };
    titleRow.getCell(1).alignment = {
      horizontal: "center",
      vertical: "middle",
    };
    titleRow.getCell(1).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFB0C4DE" },
    };

    // Agregar fecha y hora
    const dateRow = worksheet.addRow([
      `Fecha: ${data.FG}   |   Hora: ${data.HG}`,
    ]);
    worksheet.mergeCells(
      `A${dateRow.number}:${lastColLetter}${dateRow.number}`
    );
    dateRow.getCell(1).font = { italic: true, size: 12 };
    dateRow.getCell(1).alignment = { horizontal: "center", vertical: "middle" };

    // Agregar categorías
    const categoriesRow = worksheet.addRow([`Categorías: ${data.CateName}`]);
    worksheet.mergeCells(
      `A${categoriesRow.number}:${lastColLetter}${categoriesRow.number}`
    );
    categoriesRow.getCell(1).font = { bold: true, size: 14 };
    categoriesRow.getCell(1).alignment = {
      horizontal: "center",
      vertical: "middle",
    };

    // Separación
    worksheet.addRow([]);

    // Ordenar productos por categoría
    const orderedData = [...data.Productos].sort((a, b) =>
      (a.categoria_name || "").localeCompare(b.categoria_name || "")
    );

    // Estilos de encabezado
    const headerStyle = {
      font: { bold: true, size: 12 },
      alignment: { horizontal: "center", vertical: "middle" },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFCCE3F4" },
      },
      border: {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      },
    };

    // Formato de columnas
    worksheet.columns = [
      { key: "Tipo", width: 20 },
      { key: "Insumo", width: 30 },
      { key: "Cantidad", width: 15, numFmt: "#,##0.00" },
      { key: "Unidad de Medida", width: 15 },
      { key: "Costo Insumo", width: 20, numFmt: "#,##0.00" },
    ];

    orderedData.forEach((receta) => {
      // Asegurar que `Costo` y `Precio` sean números válidos
      const costo = Number(receta.Costo) || 0;
      const precio = Number(receta.Precio) || 0;

      // Agregar título de la receta
      const headerRow = worksheet.addRow([
        `Receta: ${receta.Receta} | Costo: ${costo.toFixed(2)} ${
          receta.MonedaCosto
        } | Precio: ${precio.toFixed(2)} ${receta.Moneda}`,
      ]);
      worksheet.mergeCells(
        `A${headerRow.number}:${lastColLetter}${headerRow.number}`
      );
      headerRow.getCell(1).font = { bold: true, size: 14 };
      headerRow.getCell(1).alignment = {
        horizontal: "center",
        vertical: "middle",
      };
      headerRow.getCell(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFCCE3F4" },
      };

      // Fila de encabezados
      const tableHeaderRow = worksheet.addRow(headers);
      tableHeaderRow.eachCell((cell) => Object.assign(cell, headerStyle));

      // Agregar insumos
      receta.Catalogo.forEach((insumo) => {
        // Obtener cantidad como número
        const cantidad = Number(insumo.Cantidad) || 0;

        // Obtener unidad de medida desde insumo.UM, con valor por defecto "N/A"
        const unidadMedida = insumo.UM || "N/A";

        // Asegurar que `Costo` sea numérico
        const costoInsumo = Number(insumo.Costo) || 0;
        const costoTotal = cantidad * costoInsumo;

        const row = worksheet.addRow([
          insumo.Tipo,
          insumo.Nombre,
          cantidad, // Cantidad numérica
          unidadMedida, // Unidad de medida directamente desde insumo.UM
          costoTotal, // Costo calculado
        ]);

        row.alignment = { horizontal: "center", vertical: "middle" };

        row.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          // Aplicar formato numérico a las columnas de cantidad y costo
          if (colNumber === 3 || colNumber === 5) {
            cell.numFmt = "#,##0.00";
          }
        });

        // Resaltar en rojo si el costo es 0
        if (costoInsumo === 0) {
          row.getCell(5).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFF9F8B" },
          };
        }
      });

      // Fila vacía con fondo blanco después de cada receta
      const blankRow = worksheet.addRow([]);
      blankRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFFFF" },
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    // Autoajustar columnas
    worksheet.columns.forEach((column) => {
      let maxLength = column.width || 10;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellText = cell.value ? cell.value.toString() : "";
        if (cellText.length > maxLength) {
          maxLength = cellText.length;
        }
      });
      column.width = maxLength + 2;
    });

    return workbook;
  }

  static async generateExcelBuffer(data) {
    const workbook = ProdRecetarioAYBExcel.generateWorkbook(data);
    return await workbook.xlsx.writeBuffer();
  }
}
